import i18n from '@/i18n';

import {
	type FollowingBaseInput,
	FollowingDropdownPopoverKind,
	FollowingDropdownTriggerMode,
	type FollowingLineGeneratorResult,
	type FollowingSegment,
	type InterviewPopoverData,
} from '@/components/following/types';

import {
	createInterviewDropdownSegment,
	createStatusDropdownSegment,
} from './segmentFactory';

export interface InterviewData {
	scheduledAt: string | number;
	scheduledEndAt?: string | number;
	madeBy: string;
}

export enum EntretienType {
	PLANNED = 'planned',
	COMPANY = 'company',
}

const INTERVIEW_ACCENT_COLORS: Record<EntretienType, string> = {
	[EntretienType.PLANNED]: 'var(--blue-base, #2051F8)',
	[EntretienType.COMPANY]: 'var(--purple-base, #7520E6)',
};

export const buildInterviewStatusDropdownSegment = (
	label: string,
	interviewData: InterviewData,
	type: EntretienType,
	icon = 'status-marker'
): FollowingSegment => {
	const accentColor = INTERVIEW_ACCENT_COLORS[type];
	const popoverData: InterviewPopoverData = { ...interviewData, accentColor };
	return createStatusDropdownSegment(
		label,
		accentColor,
		{ type: FollowingDropdownPopoverKind.INTERVIEW, payload: popoverData },
		{ mode: FollowingDropdownTriggerMode.HOVER, width: '236px' },
		icon
	);
};

export interface EntretienFollowingInput extends FollowingBaseInput {
	interviewData: InterviewData;
}

export const buildFollowingLineEntretien = (
	input: EntretienFollowingInput
): FollowingLineGeneratorResult => {
	const label = i18n.global.t('following.labels.entretien.planned');
	const accentColor = INTERVIEW_ACCENT_COLORS.planned;
	const mainSegment = createInterviewDropdownSegment(label, {
		...input.interviewData,
		accentColor,
	});

	return {
		icon: 'calendar-event',
		segments: [mainSegment],
		detail: input.detail,
	};
};
